import { handleGet } from "../baseAction";

export const GET_PRODUCT_CASHIER = {
  LOADING: "LOADING_PRODUCT_CASHIER",
  SUCCESS: "GET_PRODUCT_CASHIER_SUCCESS",
  ERROR: "GET_PRODUCT_CASHIER_ERROR",
};

export const GET_PRODUCT_BY_BARCODE = {
  LOADING: "LOADING_PRODUCT_BY_BARCODE",
  SUCCESS: "GET_PRODUCT_BY_BARCODE_SUCCESS",
  ERROR: "GET_PRODUCT_BY_BARCODE_ERROR",
};

export const setLoadingProduct = (load) => ({
  type: GET_PRODUCT_CASHIER.LOADING,
  load,
});

export const setProductData = (data) => ({
  type: GET_PRODUCT_CASHIER.SUCCESS,
  data,
});

export const setProductError = (error) => ({
  type: GET_PRODUCT_CASHIER.ERROR,
  error,
});

export const setLoadingProductByBarcode = (load) => ({
  type: GET_PRODUCT_BY_BARCODE.LOADING,
  load,
});

export const setProductByBarcodeData = (data) => ({
  type: GET_PRODUCT_BY_BARCODE.SUCCESS,
  data,
});

export const setProductByBarcodeError = (error) => ({
  type: GET_PRODUCT_BY_BARCODE.ERROR,
  error,
});

export const getProductCashierAction = ({
  query = "",
  offset = 0,
  limit = 25,
} = {}) => {
  return async (dispatch) => {
    dispatch(setLoadingProduct(true));

    const url = `pos/pos/cashier/inventory/products?query=${encodeURIComponent(query)}&offset=${offset}&limit=${limit}`;

    await handleGet(
      url,
      (res, ok) => {
        if (ok) {
          const products = res?.data?.data || res?.data || res || [];
          dispatch(setProductData(products));
        } else {
          dispatch(setProductError(res?.message || "Gagal memuat produk"));
          dispatch(setProductData([]));
        }
      },
      true,
      false,
    );

    dispatch(setLoadingProduct(false));
  };
};

export const getProductByBarcodeAction = (barcode) => {
  return async (dispatch) => {
    dispatch(setLoadingProductByBarcode(true));

    const url = `pos/pos/cashier/inventory/products/barcode/${barcode}`;

    await handleGet(
      url,
      (res, ok) => {
        if (ok) {
          dispatch(setProductByBarcodeData(res));
        } else {
          dispatch(
            setProductByBarcodeError(res?.message || "Produk tidak ditemukan"),
          );
          dispatch(setProductByBarcodeData(null));
        }
      },
      true,
      false,
    );

    dispatch(setLoadingProductByBarcode(false));
  };
};
